import { MEASURE_SLUGS } from "~/consts";
import { ExportTableNames } from "~/modules/downloads/types";
import {
    AggregateFunctions,
    AggregateQueryMode,
    ApiQuery,
    ApiQueryEndpoints,
    Filter,
    FilterOperators,
} from "~/modules/filters/types";
import {
    TokenTimeseriesColumns,
    TokenTimeseriesGroupBy,
} from "~/modules/token_timeseries/types";
import { TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS } from "~/modules/visualization/components/Timeseries/consts";
import {
    LegendProps,
    NavigatorControlState,
    VisualizationConfig,
    VisualizationMode,
    VisualizationModeTypes,
} from "~/modules/visualization/components/Timeseries/types";

// // // //

const BASE_QUERY: ApiQuery = {
    sort: {
        direction: "asc",
        field: "date",
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};

const visualizationConfig: VisualizationConfig = {
    area: true,
    enableZoom: false,
    showTotal: true,
    height: 350,
    legend: {
        itemWidth: 125,
        layout: "vertical",
        align: "right",
        verticalAlign: "top",
    },
};

export function getHoldersChart(props: {
    key: string;
    filters: Filter[];
    enableGroupByControls: boolean;
    defaultGroupBy: TokenTimeseriesGroupBy;
    groupByOptions: TokenTimeseriesGroupBy[];
    groupByForceUpdate?: boolean;
    loginRequired?: boolean;
    groupLimit?: number;
    legend?: LegendProps;
    navigator?: NavigatorControlState;
    height?: number;
}): VisualizationMode {
    const {
        key,
        filters,
        groupByForceUpdate = true,
        loginRequired = false,
        enableGroupByControls = true,
        defaultGroupBy = TokenTimeseriesGroupBy.asset,
        groupByOptions = [
            TokenTimeseriesGroupBy.asset,
            TokenTimeseriesGroupBy.network,
            TokenTimeseriesGroupBy.issuer,
            TokenTimeseriesGroupBy.protocol,
        ],
        groupLimit,
        legend = visualizationConfig.legend,
        navigator = {
            enabled: true,
            active: true,
            forceUpdate: true,
        },
        height,
    } = props;
    return {
        key,
        type: VisualizationModeTypes.area,
        loginRequired,
        content: {
            label: "Asset Holders",
        },
        visualizationConfig: {
            ...visualizationConfig,
            showTotal: true,
            legend,
            ...(height !== undefined && { height }),
        },
        visualizationControls: {
            stacked: {
                enabled: false,
                active: false,
                forceUpdate: true,
            },
            legend: {
                enabled: true,
                active: true,
                forceUpdate: true,
            },
            navigator: {
                ...navigator,
            },
        },
        endpoint: ApiQueryEndpoints.TokenTimeseriesV4,
        query: {
            ...BASE_QUERY,
            aggregate: {
                aggregateFunction: AggregateFunctions.Sum,
                groupBy: defaultGroupBy,
                mode: AggregateQueryMode.stock,
                groupLimit,
            },
            filter: {
                operator: FilterOperators.And,
                filters: [
                    ...filters,
                    {
                        field: TokenTimeseriesColumns.measureSlug,
                        operator: FilterOperators.Equals,
                        value: MEASURE_SLUGS.holding_addresses_count,
                    },
                ],
            },
        },
        queryControls: {
            groupBy: {
                enabled: enableGroupByControls,
                forceUpdate: groupByForceUpdate,
                value: defaultGroupBy,
                allowedOptions: groupByOptions,
            },
        },
        apiTools: TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS,
        dataExportControls: {
            enabled: true,
            filename: key,
            exportTableName: ExportTableNames.token_timeseries_v4,
        },
    };
}
